export default function IconAdd() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" fill="none">
            <path d="M9 7H16V9H9V16H7V9H0V7H7V0H9V7Z" fill="currentColor" />
        </svg>
    );
}
